var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgContactFormThanks = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 150 150"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "contact_form_thanks_svg__a",
  x1: 7.292,
  y1: 5.91,
  x2: 130.997,
  y2: 117.644,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#003ce1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.137,
  stopColor: "#492cd0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.302,
  stopColor: "#920cbd"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.452,
  stopColor: "#ca01ad"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.582,
  stopColor: "#f500a2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.686,
  stopColor: "#fd029a"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.751,
  stopColor: "#fd0397"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#d80135"
})))), /*#__PURE__*/React.createElement("path", {
  d: "M72.69 139.429C37.164 139.429 8.26 110.526 8.26 75S37.164 10.571 72.69 10.571c13.681 0 26.748 4.233 37.788 12.24a1 1 0 1 1-1.174 1.619C98.607 16.672 85.947 12.57 72.69 12.57c-34.423 0-62.429 28.006-62.429 62.429s28.006 62.429 62.429 62.429S135.12 109.423 135.12 75c0-4.497-.481-8.985-1.43-13.34a1 1 0 0 1 1.956-.426A64.887 64.887 0 0 1 137.119 75c0 35.526-28.902 64.429-64.429 64.429Zm72.997-103.791L129.929 19.88l-56.84 56.84-21.21-21.236L36.094 71.27l36.993 36.967 72.599-72.598Zm-93.81 22.675 21.21 21.237 56.842-56.842 12.93 12.93-69.77 69.77-34.165-34.14 12.953-12.955ZM124.147 96.914c2.967-6.943 4.472-14.316 4.472-21.914a.5.5 0 1 0-1 0c0 7.462-1.477 14.702-4.391 21.521a.5.5 0 0 0 .92.393Zm-22.954 26.192a.5.5 0 1 0-.511-.859 54.778 54.778 0 0 1-27.992 7.682.5.5 0 1 0 0 1 55.784 55.784 0 0 0 28.503-7.823ZM73.19 130.43a.5.5 0 0 0-.5-.5c-30.288 0-54.929-24.64-54.929-54.929S42.402 20.071 72.69 20.071c8.769 0 17.13 1.992 24.848 5.922a.501.501 0 0 0 .453-.892c-7.86-4-16.373-6.03-25.301-6.03-30.84 0-55.929 25.09-55.929 55.929s25.09 55.929 55.929 55.929a.5.5 0 0 0 .5-.5Zm-.147-32.692a.5.5 0 0 0 0-.707L53.401 77.402a.5.5 0 1 0-.707.707l19.642 19.628a.498.498 0 0 0 .707 0Z",
  style: {
    fill: "url(#contact_form_thanks_svg__a)"
  }
}));
export default SvgContactFormThanks;